import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../app/user/userSlice";
import arrowtoleft from "../../images/icons/green-arrow-left.svg";
import arrowtoright from "../../images/icons/green-arrow-right.svg";

export const MenuHeader = ({ openMenu, handelOpenMenu }) => {
  const [innerShow, setInnerShow] = useState(false);
  const [initials, setInitials] = useState("");
  const getEmail = JSON.parse(localStorage.getItem("dbhuseread"));
  const { name: user } = getEmail;
  
  useEffect(() => {
    if (openMenu) {
      setTimeout(() => {
        setInnerShow(openMenu);
      }, 300);
    } else {
      setInnerShow(openMenu);
    }
  }, [openMenu]);

  useEffect(() => {
    formatInitials();
  }, [initials]);

  const formatInitials = () => {
    let nameArray = user.split(" ");

    if (nameArray.length >= 2) {
      setInitials(nameArray[0][0] + nameArray[1][0]);
    } else {
      setInitials(nameArray[0][0] + nameArray[0][1]);
    }
  };

  const getUserName = (username = "") => {
    const usernameArr = username.split(" ");

    if(usernameArr.length === 1) {
      return usernameArr[0]
    }

    if(usernameArr.length === 2) {
      return `${usernameArr[0]} ${usernameArr[1]}`
    }

    if(usernameArr.length === 3) {
      return `${usernameArr[0]} ${usernameArr[2]}`
    }

    if(usernameArr.length === 4) {
      return `${usernameArr[0]} ${usernameArr[2]}`
    }

    if(usernameArr.length === 5) {
      return `${usernameArr[0]} ${usernameArr[3]}`
    }
  }

  return (
    <div className="menu-header">
      {openMenu ? (
        <div className="menu-header__row">
          <div className="menu-header__col1" onClick={handelOpenMenu}>{initials}</div>
          <div className="menu-header__col2">
            {innerShow && (
              <>
                <label className="menu-header__col2-greetings">Hola</label>
                <label className="menu-header__col2-name">{getUserName(user) || ""}</label>
              </>
            )}
          </div>
        </div>
      ) : (
        <div>
          <div className="menu-header__col1" onClick={handelOpenMenu}>{initials}</div>
        </div>
      )}
    </div>
  );
};
